/** Levels that use Code.org section codes (teacher portal). */
export const SECTION_CODE_LEVELS = [1, 2, 8] as const;

/** Base URL for Code.org classroom sections (no trailing slash). */
export const CODE_ORG_SECTION_BASE_URL = 'https://studio.code.org';

export type PracticeLinkInput = {
    code?: string | null;
    package?: { practiceLink?: string | null; level?: number | string | null } | null;
    partner_package?: { practiceLink?: string | null; level?: number | string | null } | null;
};

function stripTrailingSlashes(url: string): string {
    return url.replace(/\/+$/, '');
}

function isCodeOrgPracticeUrl(url: string): boolean {
    return /(?:^https?:\/\/)?(?:[\w-]+\.)?code\.org/i.test(url);
}

function packageMeta(program: PracticeLinkInput) {
    const pkg = program.partner_package || program.package;
    return {
        practiceLink: pkg?.practiceLink?.trim() || null,
        level: Number(pkg?.level),
    };
}

/**
 * Builds the parent/partner "Practice" URL.
 * Section codes (levels 1, 2, 8) always use a Code.org base — never Code Combat.
 */
export function buildPracticeLink(program: PracticeLinkInput): string | null {
    const { practiceLink, level } = packageMeta(program);
    if (!practiceLink) return null;

    const sectionCode = program.code?.trim();
    const usesSectionCode =
        Boolean(sectionCode) && SECTION_CODE_LEVELS.includes(level as (typeof SECTION_CODE_LEVELS)[number]);

    if (usesSectionCode) {
        const base = isCodeOrgPracticeUrl(practiceLink)
            ? stripTrailingSlashes(practiceLink)
            : CODE_ORG_SECTION_BASE_URL;
        return `${base}/sections/${sectionCode}`;
    }

    return stripTrailingSlashes(practiceLink);
}
